import * as React from 'react'
import {
  IModal
} from '../types'
import AboutModal from './about-modal'
import NameModal from './name-modal'
import SavedModal from './saved-modal'
import SettingsModal from './settings-modal'
import PrivacyModal from './privacy-modal'
import FTCModal from './ftc-modal';


export default class Modal extends React.PureComponent<{
  modal: IModal
  savedNames: string[]
  onClose: () => void
  onSaveName: (name: string) => void
}> {

  render() {
    const {
      modal,
      savedNames,
      onClose,
      onSaveName
    } = this.props

    if (!modal) {
      return <div />
    }

    switch (modal.type) {
      case 'name':
        return (
          <NameModal
            name={modal.name}
            state={modal.state}
            isSaved={savedNames.indexOf(modal.name) >= 0}
            onClose={onClose}
            onSave={onSaveName}
          />
        )
      case 'about':
        return (
          <AboutModal
            onClose={onClose}
          />
        )
      case 'saved':
        return (
          <SavedModal
            names={savedNames}
            onClose={onClose}
            onRemove={onSaveName}
          />
        )
      case 'settings':
        return (
          <SettingsModal
            onClose={onClose}
          />
        )
      case 'privacy' :
        return (
          <PrivacyModal
            onClose={onClose}
          />
        )
      case 'ftc' : 
          return (
            <FTCModal
              onClose={onClose}
            />
          )
    }
  }

}


// WEBPACK FOOTER //
// ./src/comp/modal.tsx